export const REPORT_HLE = 'REPORT_HLE';
export const REPORT_QUOTA = 'REPORT_QUOTA';

export const REPORT_HLE_SAVE = 'hle';
export const REPORT_QUOTA_SAVE = 'uq';

export const REPORT_CUSTOM = 'REPORT_CUSTOM';